import { paths } from 'src/routes/paths';

// API
// ----------------------------------------------------------------------

export const HOST_API = import.meta.env.VITE_HOST_API;
export const ASSETS_API = import.meta.env.VITE_ASSETS_API;

export const FIREBASE_API = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APPID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

export const AMPLIFY_API = {
  userPoolId: import.meta.env.VITE_USER_POOL_ID,
  userPoolWebClientId: import.meta.env.VITE_USER_POOL_APP_CLIENT_ID,
  region: "eu-central-1",
};

export const MAPBOX_API = import.meta.env.VITE_MAPBOX_API;

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = paths.dashboard.root; // as '/dashboard'

export const TIMESHEET_EDITABLE_TYPES = ['manual', 'precompiled_employee', 'precompiled_employee_clocking'];

export const CLOCKING_DRIVEN_TIMESHEET_TYPES = ['clocking', 'presence_clocking'];

export const TIMESHEET_TYPES_WITH_CLOCKINGS = [
  ...CLOCKING_DRIVEN_TIMESHEET_TYPES,
  'precompiled_employee_clocking',
  'precompiled_company_clocking',
];

export const hasClockingDrivenTimesheet = (type) => CLOCKING_DRIVEN_TIMESHEET_TYPES.includes(type);
export const hasTimesheetClockings = (type) => TIMESHEET_TYPES_WITH_CLOCKINGS.includes(type);
export const timesheetTypeGeneratesAnomalies = (type) => type !== 'presence_clocking';
